__turbopack_context__.v({
  "liveBadge": "LiveBadge-module-scss-module__0sHAPW__liveBadge",
  "liveBadgeCircle": "LiveBadge-module-scss-module__0sHAPW__liveBadgeCircle",
});
